import React from 'react';
import { Check as CheckIcon, Warning as WarningIcon } from '@mui/icons-material';
var ContentIcon = function (props) {
    var success = props.success, _a = props.successIcon, successIcon = _a === void 0 ? React.createElement(CheckIcon, null) : _a, error = props.error, _b = props.errorIcon, errorIcon = _b === void 0 ? React.createElement(WarningIcon, null) : _b, children = props.children;
    if (success && !error)
        return successIcon;
    if (error && !success)
        return errorIcon;
    return children;
};
ContentIcon.defaultProps = {
    successIcon: React.createElement(CheckIcon, null),
    errorIcon: React.createElement(WarningIcon, null),
};
export default ContentIcon;
//# sourceMappingURL=ContentIcon.js.map